import { Injectable, Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { RemovableExamination, RemoveExamComponent, RemoveExamDialogData } from './remove-exam.component';
import { IReportWorkflowExamService, REPORT_WORKFLOW_EXAM_SERVICE_TOKEN } from '@se/platform';

@Injectable({
    providedIn: 'root',
})
export class RemoveExamService {
    constructor(
        private dialog: MatDialog,
        private injector: Injector,
        private translate: TranslateService,
    ) {}

    removeExamination(
        examService: IReportWorkflowExamService,
        examination : RemovableExamination) {
        const data: RemoveExamDialogData = {
            header: this.buildHeader(examination),
            examination,
        };

        const injector = Injector.create({
            parent: this.injector,
            providers: [
                {
                    provide: REPORT_WORKFLOW_EXAM_SERVICE_TOKEN,
                    useValue: examService,
                },
            ],
        });

        return this.dialog.open(RemoveExamComponent, { data, injector }).afterClosed();
    }

    private buildHeader(examination: RemovableExamination) {
        return (
            this.translate.instant('TitleRemoveExam') +
            ' - ' +
            (examination?.patient.lastName || '').toUpperCase() +
            ' ' +
            (examination?.patient.firstName || '').toUpperCase() +
            ' - ' +
            examination?.exam.description
        );
    }
}
